import { render, staticRenderFns } from "./WorkflowFormBuilderListPage.vue?vue&type=template&id=47ee95ed&"
import script from "./WorkflowFormBuilderListPage.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports